import { createSelector } from 'reselect';
import constants from '../../../common/constants/CommonConstants';
import { canUserEditContact } from '../../../common/util/authUtils';
import { selectLoggedInUser } from '../userSelector';

const contacts = (state) => state.contacts.list;

const enrichWithEditPermissionCheck = (contactList, loggedInUser) => {
  const { roleName: role } = loggedInUser;
  const canCurrentUserEditEntity = canUserEditContact(role);
  return contactList.map((contact) => {
    return {
      ...contact,
      canCurrentUserEditEntity,
    };
  });
};

const contactSelector = createSelector(
  contacts,
  selectLoggedInUser,
  enrichWithEditPermissionCheck
);

export default contactSelector;

export const contactsPartialListSelector = createSelector(
  (state) => state.entityPartialList.list[constants.CONTACT_LEVEL],
  selectLoggedInUser,
  enrichWithEditPermissionCheck
);

const contactStats = (state) => state.contacts.statbarData;
export const contactStatsSelector = createSelector(
  contactStats,
  (stats) => stats
);

const listPageData = (state) => state.contacts.listPageData;
export const listPageDataSelector = createSelector(
  listPageData,
  (data) => data
);
